import React, { useEffect, useState } from 'react'
// import Modal from '../../../components/Modal'
import styles from '../styles.module.css'
import Button from '../../../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import Table from '../../../../components/Table'
import { createParentMeetingFile, deleteParentMeetingFile } from '../../../../actions/parent_meetings'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../../../components/Confirmation/Confirmation'
import { api } from '../../../../App'
import ModalFooter from '../../../../components/ModalFooter/ModalFooter'
import { downloadFile } from '../../../../utils/fileDownload'


export default function ModalComponent({ data, closeModal, handleSubmit, addMode }) {

  const dispatch = useDispatch()
  const { parentMeetingsFiles } = useSelector(state => state.parent_meetings)

  const [file, setFile] = useState(null)
  const [fileForDelete, setFileForDelete] = useState(null)
  const [image, setImage] = useState(null);
  const [fileSelected, setFileSelected] = useState(null) /// из списка имя

  const handlePick = () => {
    document.getElementById('filePicker').click()
  }
  const handleChangeFile = (e) => {
    setFile(Object.values(e.target.files)[0])
  }

  useEffect(() => {
    data?.pmid && file && dispatch(createParentMeetingFile(file, data?.pmid))
  }, [data?.pmid, file])

  useEffect(() => {
    (parentMeetingsFiles && fileSelected) && fetchPhoto(fileSelected, data?.pmid)
  }, [fileSelected])

  const handleTakeFile = (file_name) => {
    setFileSelected(file_name)
  }
  const fetchPhoto = async (file_name, id) => {
    const { data } = await api.get(`/parent_meetings/${id}/file/${file_name}`, { responseType: 'blob' });
    const url = URL.createObjectURL(data)
    setImage(url)
    downloadFile(data, file_name, { 
      openInNewTab: true,
      onComplete: () => {
        // URL уже используется в setImage, не освобождаем здесь
      }
    })
  }
  const renderLi = (data) => {
    const { file_name, file_size } = data
    return (
      <tr key={file_size} onClick={() => handleTakeFile(file_name)}>
        <td>{file_name}</td>
        <td><i className={styles.trash} onClick={deleteClickHandler({ id: file_size, name: file_name })}><BiTrash /></i></td>
      </tr>
    )
  }
  const closeModalEmpty = () => {
    closeModal()
  }
  const deleteClickHandler = (wid) => (e) => {
    e.stopPropagation()
    setFileForDelete(wid)
  }

  const acceptConfirm = () => {
    dispatch(deleteParentMeetingFile(data.pmid, fileForDelete.name))
    setFileForDelete(null)
  }

  const rejectConfirm = () => {
    setFileForDelete(null)
  }
  return (
    <>
      <div className={styles.tabWrapper} style={{ height: '380px' }}>
        {fileForDelete &&
          <Confirmation
            title={`Вы уверены что хотите удалить ${fileForDelete.name}?`}
            acceptConfirmation={acceptConfirm}
            rejectConfirmation={rejectConfirm}
          />
        }
        <div className={styles.inputsRow}>
          <br />
          <div className={styles.buttons_wrap}>
            <div className={styles.buttons}>
              <>
                <Button onClick={handlePick}>{'Добавить'}</Button>
                <input
                  className={styles.hidden}
                  type='file'
                  onChange={(e) => handleChangeFile(e)}
                  accept="image/*"
                  id='filePicker'
                />
              </>

            </div>
          </div>
          <br />
          <Table className={styles.tables}>
            <tbody>
              {!!parentMeetingsFiles && parentMeetingsFiles?.map(renderLi)}
            </tbody>
          </Table>
          {!!image &&
            <img
              src={image}
              alt="0_o"
              height={350}
              width={450}
            />
          }
        </div>
      </div>
      <ModalFooter closeModal={closeModalEmpty} handleSubmit={handleSubmit} />
    </>
  )
}
